export function appendScript(scriptSrc: string) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = scriptSrc
    const body = document.querySelector('body')
    body && body.appendChild(script)
    script.addEventListener('load', resolve)
    script.addEventListener('error', reject)
  })
}
